import React from "react";
import styled from "styled-components";

import Badge from "@examspark/common-ui/dist/components/text/Badge";

const StyledBadge = styled(Badge)<{ bankId?: string }>`
  text-transform: uppercase;
  color: white;

  background-color: ${(props) => {
    if (props.bankId?.match(/trs|teksrs/)) return "#58c54e";
    if (props.bankId?.match(/tcr/)) return "#a78cdf";
    return "#888";
  }};
`;

const BankBadge = (props: {
  bankId: string | null | undefined;
  plain?: boolean;
}) => {
  let label = "N/A";
  if (props.bankId?.match(/trs|teksrs/)) label = "TEKS RS";
  if (props.bankId?.match(/tcr/)) label = "TCR";

  if (props.plain) {
    return <div>{label}</div>;
  }

  return <StyledBadge>{label}</StyledBadge>;
};

export default BankBadge;
